import { render } from "./Login.vue?vue&type=template&id=98ac38cc&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=98ac38cc&lang=scss&scoped=true"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bylex_platform/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98ac38cc"]])

export default __exports__